export const MINUTES_PER_HOUR = 60;
export const MINUTES_PER_DAY = 24 * MINUTES_PER_HOUR;

export type DurationUnit = 'minutes' | 'hours' | 'days';

export const leadTimeDaysToMinutes = (days: number): number => days * MINUTES_PER_DAY;

export const leadTimeMinutesToDays = (minutes: number): number =>
  Math.round(minutes / MINUTES_PER_DAY);

export const durationDisplayToMinutes = (amount: number, unit: DurationUnit): number => {
  const n = Number(amount);
  if (!Number.isFinite(n) || n < 0) {
    return 0;
  }
  switch (unit) {
    case 'days':
      return Math.round(n * MINUTES_PER_DAY);
    case 'hours':
      return Math.round(n * MINUTES_PER_HOUR);
    default:
      return Math.round(n);
  }
};

export const minutesToDurationDisplay = (
  minutes: number
): { amount: number; unit: DurationUnit } => {
  const m = Math.max(0, Math.round(Number(minutes) || 0));
  if (m === 0) {
    return { amount: 0, unit: 'minutes' };
  }
  if (m % MINUTES_PER_DAY === 0) {
    return { amount: m / MINUTES_PER_DAY, unit: 'days' };
  }
  if (m % MINUTES_PER_HOUR === 0) {
    return { amount: m / MINUTES_PER_HOUR, unit: 'hours' };
  }
  return { amount: m, unit: 'minutes' };
};

export const minutesToAmountInUnit = (minutes: number, unit: DurationUnit): number => {
  const m = Math.max(0, Math.round(Number(minutes) || 0));
  switch (unit) {
    case 'days':
      return m / MINUTES_PER_DAY;
    case 'hours':
      return m / MINUTES_PER_HOUR;
    default:
      return m;
  }
};

export const isCancellationAllowed = (
  startTime: Date | string,
  cancellationLeadTimeMinutes: number,
  now: Date = new Date()
): boolean => {
  const start = new Date(startTime);
  if (Number.isNaN(start.getTime())) {
    return false;
  }

  if (now > start) {
    return false;
  }

  if (cancellationLeadTimeMinutes <= 0) {
    return true;
  }

  const cutoff = new Date(start.getTime() - cancellationLeadTimeMinutes * 60_000);
  return now <= cutoff;
};
